export const ALL_CITIES_ID = 0
export const ALL_CITIES_VALUE = String(ALL_CITIES_ID)
